import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Minus Circle Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M185.895 128c0 5.329-4.32 9.649-9.649 9.65H79.754c-7.428 0-12.07-8.042-8.357-14.475a9.65 9.65 0 0 1 8.357-4.824h96.492c5.33 0 9.65 4.32 9.65 9.649m67.545 0c0 96.564-104.533 156.916-188.16 108.634s-83.627-168.986 0-217.268A125.46 125.46 0 0 1 128 2.56c69.248.073 125.367 56.192 125.44 125.44m-19.298 0c0-81.708-88.452-132.775-159.213-91.921s-70.76 142.988 0 183.842A106.16 106.16 0 0 0 128 234.141c58.593-.066 106.075-47.548 106.142-106.141" }, null, -1)
  ]))]))
}
export default { render: render }